// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b6bb40a","returns":"_e54d239","description":"_db68499","value":"_5af4800","bonusCash":"_0d67eae","returnValue":"_325d9eb","returnValuePriceChange":"_6f62cf5"};